<template>
    <div class="bets">
        <div class="bets-nav">
            <button v-if="authUser.user !== null" v-on:click="betsSetTab('my')" class="nav-link" v-bind:class="{ 'link-active': betsTab === 'my' }">MY BETS</button>
            <button v-on:click="betsSetTab('all')" class="nav-link" v-bind:class="{ 'link-active': betsTab === 'all' }">ALL</button>
            <button v-on:click="betsSetTab('whale')" class="nav-link" v-bind:class="{ 'link-active': betsTab === 'whale' }">WHALE WINS</button>
            <button v-on:click="betsSetTab('lucky')" class="nav-link" v-bind:class="{ 'link-active': betsTab === 'lucky' }">LUCKY WINS</button>
        </div>
        <div class="bets-toggle-row">
            <span class="bets-toggle-dot" :class="{ 'is-on': generalLiveBetsEnabled }" aria-hidden="true"></span>
            <span class="bets-toggle-label">Live Bets</span>
            <button
                type="button"
                class="bets-toggle-switch"
                :class="{ 'is-on': generalLiveBetsEnabled }"
                :aria-pressed="generalLiveBetsEnabled"
                aria-label="Toggle live bets updates"
                @click="toggleLiveBets"
            >
                <span class="bets-toggle-thumb"></span>
            </button>
        </div>
        <div class="bets-list">
            <div class="list-head list-head-desktop">
                <div class="head-game">GAME</div>
                <div class="head-user">USER</div>
                <div class="head-time">TIME</div>
                <div class="head-wager">WAGER</div>
                <div class="head-multiplier">MULTIPLIER</div>
                <div class="head-payout">PAYOUT</div>
            </div>
            <div class="list-head list-head-mobile">
                <div class="head-player">Player</div>
                <div class="head-payout">Payout</div>
                <div class="head-multi">Multi</div>
            </div>
            <div class="list-content">
                <transition name="fade" mode="out-in">
                    <div v-if="generalBets.bets === null || generalBets.loading === true" class="content-loading" key="loading">
                        <LoadingAnimation />
                    </div>
                    <div v-else-if="betsGetList.length > 0" class="content-list" key="data">

                        <BetsElement v-for="bet in betsGetList" v-bind:key="bet._id + betsTab" v-bind:bet="bet" />

                    </div>
                    <div v-else class="content-empty" key="empty">No bets found.</div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import LoadingAnimation from '@/components/LoadingAnimation';
    import BetsElement from '@/components/bets/BetsElement';

    export default {
        name: 'Bets',
        components: {
            LoadingAnimation,
            BetsElement
        },
        data() {
            return {
                betsTab: 'all'
            }
        },
        methods: {
            ...mapActions([
                'generalGetBetsDataSocket',
                'generalSetLiveBetsEnabled'
            ]),
            betsSetTab(tab) {
                this.betsTab = tab;
            },
            toggleLiveBets() {
                this.generalSetLiveBetsEnabled(!this.generalLiveBetsEnabled);
            }
        },
        computed: {
            ...mapGetters([
                'authUser', 
                'generalBets',
                'generalLiveBetsEnabled'
            ]),
            betsGetList() {
                let bets = [];

                if(this.generalBets.bets !== null && this.generalBets.bets[this.betsTab] !== undefined) {
                    bets = this.generalBets.bets[this.betsTab].slice(0, 12);
                }

                return bets;
            }
        },
        created() {
            if(this.generalBets.bets === null && this.generalBets.loading === false) {
                const data = {};
                this.generalGetBetsDataSocket(data);
            }
        }
    }
</script>

<style scoped>
    .bets {
        width: 1050px;
        margin-top: 50px;
        position: relative;
        z-index: 1;
    }

    .bets .bets-nav {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 2;
    }

    .bets .bets-nav button.nav-link {
        position: relative;
        margin-right: 40px;
        padding-bottom: 23px;
        font-size: 16px;
        font-weight: 600;
        color: white;
        transition: all 0.3s ease;
        background: transparent;
        border: none;
        cursor: pointer;
        z-index: 1;
    }

    .bets .bets-nav button.nav-link:last-of-type {
        margin-right: 0;
    }

    .bets .bets-nav button.nav-link::after {
       content: '';
       width: 100%;
       height: 1px;
       position: absolute;
       left: 0;
       bottom: 0;
       background-color: var(--accent-red);
       transition: all 0.3s ease;
       opacity: 0;
   }

   .bets .bets-nav button.nav-link.link-active {
       color: var(--accent-yellow);
   }

   .bets .bets-nav button.nav-link.link-active::after {
       opacity: 1;
   }

   .bets-toggle-row {
       display: flex;
       align-items: center;
       gap: 10px;
       margin-top: 16px;
       margin-bottom: 16px;
   }

   .bets-toggle-dot {
       width: 8px;
       height: 8px;
       border-radius: 50%;
       background: rgba(255, 255, 255, 0.25);
       flex-shrink: 0;
       transition: background 0.2s ease;
   }

   .bets-toggle-dot.is-on {
       background: var(--accent-blue, #7c8db5);
   }

   .bets-toggle-label {
       font-size: 14px;
       font-weight: 500;
       color: white;
   }

   .bets-toggle-switch {
       margin-left: auto;
       width: 44px;
       height: 24px;
       border-radius: 12px;
       background: rgba(255, 255, 255, 0.12);
       border: none;
       cursor: pointer;
       position: relative;
       padding: 0;
       transition: background 0.2s ease;
   }

   .bets-toggle-switch:hover {
       background: rgba(255, 255, 255, 0.18);
   }

   .bets-toggle-switch.is-on {
       background: rgba(124, 141, 181, 0.5);
   }

   .bets-toggle-switch.is-on:hover {
       background: rgba(124, 141, 181, 0.65);
   }

   .bets-toggle-thumb {
       position: absolute;
       top: 2px;
       left: 2px;
       width: 20px;
       height: 20px;
       border-radius: 50%;
       background: rgba(255, 255, 255, 0.4);
       transition: transform 0.2s ease;
   }

   .bets-toggle-switch.is-on .bets-toggle-thumb {
       transform: translateX(20px);
       background: var(--accent-blue, #9ca8c4);
   }

   .bets-toggle-switch:focus-visible {
       outline: 2px solid var(--accent-blue, #7c8db5);
       outline-offset: 2px;
   }

   .bets .bets-list {
       width: 100%;
       height: 440px;
       position: relative;
       border-radius: var(--radius-lg);
       overflow: hidden;
       background: var(--bg-secondary);
       box-shadow: var(--shadow-sm);
   }

   .bets .bets-list::after {
       content: '';
       width: 100%;
       height: 28px;
       position: absolute;
       bottom: 0;
       left: 0;
       background: linear-gradient(0deg, rgba(26, 26, 26, 0.75) 0%, rgba(26, 26, 26, 0) 100%);
       z-index: 1;
   }

   .bets .list-head {
        width: 100%;
        height: 52px;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 35px;
        background: var(--bg-table-background);
        border: 1px solid var(--accent-blue-dark);
   }

   .bets .list-head-mobile {
        display: none;
   }

   .bets .head-game {
       width: 20%;
       font-weight: 700;
       font-size: 12px;
       color: var(--text-muted);
       text-transform: uppercase;
       letter-spacing: 1px;
   }

   .bets .head-user {
       width: 20%;
       font-weight: 700;
       font-size: 12px;
       color: var(--text-muted);
       text-transform: uppercase;
       letter-spacing: 1px;
   }

   .bets .head-time {
       width: 20%;
       font-weight: 700;
       font-size: 12px;
       color: var(--text-muted);
       text-transform: uppercase;
       letter-spacing: 1px;
   }

   .bets .head-wager {
        width: 15%;
        font-weight: 700;
        font-size: 12px;
        color: var(--text-muted);
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .bets .head-multiplier {
        width: 10%;
        font-weight: 700;
        font-size: 12px;
        color: var(--text-muted);
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .bets .head-payout {
        width: 15%;
        text-align: right;
        font-weight: 700;
        font-size: 12px;
        color: var(--text-muted);
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .bets .list-content {
        width: 100%;
        height: calc(100% - 52px);
        overflow: hidden;
    }

    .bets .content-loading {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .bets .content-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .bets .content-loading.fade-leave-to {
        opacity: 0;
    }

    .bets .content-data {
        width: 100%;
    }

    .bets .content-empty {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: 600;
        color: #5e768e;
    }

    .bets .content-list.fade-enter-active,
    .bets .content-empty.fade-enter-active {
        transition: opacity 0.5s;
    }

    .bets .content-list.fade-enter-from,
    .bets .content-empty.fade-enter-from {
        opacity: 0;
    }

   @media only screen and (max-width: 1100px) {

       .bets {
           width: 100%;
       }

   }

   @media only screen and (max-width: 950px) {

       .bets {
           position: absolute;
           left: 0;
           bottom: 0;
           margin-top: 0;
       }

       .bets .bets-nav button.nav-link {
           padding-bottom: 8px;
       }

       .bets .bets-list {
            height: 388px;
            border-radius: 0;
        }

       .bets .list-head-desktop {
            display: none;
       }

       .bets .list-head-mobile {
            display: flex;
            height: 44px;
            padding: 0 16px;
            border-bottom: 1px solid rgba(255, 255, 255, 0.08);
       }

       .bets .list-head-mobile .head-player {
            flex: 1;
            text-align: left;
            font-weight: 600;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.7);
            text-transform: uppercase;
            letter-spacing: 0.5px;
       }

       .bets .list-head-mobile .head-payout {
            flex: 0 0 90px;
            text-align: center;
            font-weight: 600;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.7);
            text-transform: uppercase;
            letter-spacing: 0.5px;
       }

       .bets .list-head-mobile .head-multi {
            flex: 0 0 60px;
            text-align: right;
            font-weight: 600;
            font-size: 11px;
            color: rgba(255, 255, 255, 0.7);
            text-transform: uppercase;
            letter-spacing: 0.5px;
       }

       .bets .list-content {
            height: calc(100% - 44px);
        }

   }

   @media only screen and (max-width: 600px) {

       .bets .bets-nav button.nav-link {
           margin-right: 15px;
           font-size: 12px;
       }

   }
</style>
